import { getSessionClientInformation } from "app/utils/utility.service";
import {getSessionUserInformation, getSessionAgentInformation,getSessionBrokerInformation } from "app/utils/utility.service";
import { useState } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";

const ReportHeader = () => {

    let sessionValues = getSessionUserInformation();
    let agentValues = getSessionAgentInformation();
    if(!agentValues && sessionValues.roleId === 3) {
        agentValues = sessionValues;
    }
    const clientInfo = getSessionClientInformation();
    if(clientInfo) {
        sessionValues = clientInfo;
    }
    const brokerValues = getSessionBrokerInformation();
    const [disableLogoLink, setDisableLogoLink] = useState(false);
    return (
        <div className="header">
        <div className="left">
            {disableLogoLink ? (
                <img src="/myhouserlogo.png" alt="Company" />
            ) : (
                <Link to="/">
                    <img src="/myhouserlogo.png" alt="Company" />
                </Link>
            )}
        </div>
        <div className="col-3">
            <div className="text-center">
                {sessionValues &&
                    sessionValues.roleId === 2 &&
                    sessionValues?.companyImagePath && (
                        <Fragment>
                            <img
                                className="ml-4 mr-4"
                                src={`${process.env.REACT_APP_API_BASE_URL}/fetchImages/${sessionValues?.companyImagePath}`}
                                alt="Profile"
                                style={{
                                    width: "auto",
                                    height: "70px",
                                }}
                            />
                        </Fragment>
                    )}
                {brokerValues &&
                    brokerValues.id &&
                    brokerValues.companyImagePath && (
                        <Fragment>
                            <div>
                                <img
                                    className="ml-4 mr-4"
                                    src={`${process.env.REACT_APP_API_BASE_URL}/fetchImages/${brokerValues?.companyImagePath}`}
                                    alt="Company"
                                    style={{
                                        width: "auto",
                                        height: "70px",
                                    }}
                                />
                                {/* <div className="text-center">
                                    <label
                                        style={{
                                            fontWeight: "500",
                                        }}
                                    >{`Broker: ${brokerValues.firstName} ${brokerValues.lastName}`}</label>
                                </div> */}
                            </div>
                        </Fragment>
                    )}
                {/* <img
                    style={{ height: "10rem" }}
                    src="/company.png"
                    alt="Company"
                /> */}
            </div>
        </div>
        <div className="col-3">
            {agentValues && agentValues.id && (
                <div className="main-content-background text-center">
                    <p>
                        <span style={{ fontWeight: "700" }}>
                            {`${agentValues?.firstName} ${agentValues?.lastName}`}
                        </span>
                        {/* , MBA, Realtor DRE#: 01330948 */}
                    </p>
                    {/* <p>ABR, SRES, CRS</p> */}
                    <p>{`${agentValues?.address} - ${agentValues?.city}: ${agentValues?.zipcode}`}</p>
                    <p>{`${agentValues?.phoneNumber}`}</p>
                    <p> {`${agentValues?.email}`}</p>
                </div>
            )}
        </div>
        <div className="col-3">
            <div className="text-center">
                {agentValues &&
                    agentValues.id &&
                    agentValues.profileImagePath && (
                        <Fragment>
                            <div>
                                <img
                                    className="ml-4 mr-4"
                                    src={`${process.env.REACT_APP_API_BASE_URL}/fetchImages/${agentValues?.profileImagePath}`}
                                    alt="Profile"
                                    style={{
                                        width: "auto",
                                        height: "70px",
                                    }}
                                />
                                {/* <div className="text-center">
                                <label
                                    style={{ fontWeight: "500" }}
                                >{`Agent: ${agentValues.firstName} ${agentValues.lastName}`}</label>
                            </div> */}
                            </div>
                        </Fragment>
                    )}
                {/* <img
                    style={{ height: "10rem" }}
                    src="/profileImage.png"
                    alt="Profile"
                /> */}
            </div>
        </div>
    </div>
    )
}

export default ReportHeader;